import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { API } from "@/App";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from hash fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error("Invalid authentication response");
          navigate("/login");
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data and token
        const response = await axios.get(`${API}/auth/session?session_id=${sessionId}`);
        const { access_token, user } = response.data;

        // Store auth data
        localStorage.setItem("token", access_token);
        localStorage.setItem("user", JSON.stringify(user));

        toast.success(`Welcome, ${user.name}!`);

        // Redirect based on role
        const routes = {
          tenant: "/tenant",
          contractor: "/contractor",
          landlord: "/landlord",
          admin: "/admin"
        };
        
        // Use replace to prevent going back to callback
        navigate(routes[user.role] || "/tenant", { replace: true, state: { user } });
      } catch (error) {
        console.error("Auth callback error:", error);
        toast.error("Authentication failed. Please try again.");
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto mb-4" />
        <p className="text-lg text-slate-600">Completing sign in...</p>
      </div>
    </div>
  );
};
